import { ActionBase } from '../../../core/store/action/ActionBase';

export const ACTIVATE_DRAFT_MESSAGE_TO_USERS_SUCCESS_ACTION = '[Configuration] Activate Draft Message to Users Success Action';

export class ActivateDraftMessageToUsersSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_MESSAGE_TO_USERS_SUCCESS_ACTION;

  constructor(public payload: { activatedMessageToUsers: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/ActivateDraftMessageToUsersSuccessAction.ts